<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.dateRange}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.selectionCriteria}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="allSelectedList" v-model="reportForm.polType" :label="labels.polType" item-text="label" item-value="value"
                          data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" v-validate="'required'"
                          :loading="loading" @change="doPolType"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6 v-if="reportForm.polType === 'Selected'">
                          <v-autocomplete :items="polTypeList" v-model="reportForm.cPolType" :label="labels.cPolType" item-text="label" item-value="value" multiple
                          data-vv-name="cPolType" :data-vv-as="labels.cPolType" :error-messages="errors.collect('cPolType')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field v-model="reportForm.intermediary" :label="labels.intermediary" :error-messages="errors.collect('intermediary')" data-vv-name="intermediary"
                          :data-vv-as="labels.intermediary" append-icon="mdi-magnify" @click:append="getHelpList()" readonly></v-text-field>
                        </v-flex>

                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="agentHelpList" width="900px" persistent>
      <multi-intermediary-help-list :intr="reportForm.intermediary" :helpListTitle="helpListTitle"
      :intrGrp="intrGrp" :listName="'billAcctNoList'" @close="doClose" @doAssign="doAssign($event)"></multi-intermediary-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        selectionCriteria: 'Selection Criteria',
        polType: 'Policy Type(s)',
        cPolType: 'Selected Policy Type(s)*',
        intermediary: 'Billing Agent(s)',
        export: 'Export To',
        format: 'ASCII TEXT',
        pbPrtParam: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        polType: 'All',
        cPolType: '',
        intermediary: 'All',
        format: undefined,
        pbPrtParam: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      polTypeList: [],
      agentHelpList: false,
      helpListTitle: 'Billing Agent(s) Helplist',
      intrGrp: '10,11,12,20,25',
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
  },
  methods: {
    async doInit() {
      this.reportForm.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initPremiumIncome
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getPolTypeList()
      } catch (err) {
        throw err
      }
    },
    async getPolTypeList() {
      const apiURI = this.menu.polTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.polTypeList = []
          if (data) {
            for (let i in data) {
              this.polTypeList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doPolType() {
      if (this.reportForm.polType === 'Selected') {
        this.reportForm.cPolType = ''
      }
    },
    doClose() {
      this.agentHelpList = false
    },
    async doAssign(Obj) {
      this.reportForm.intermediary = Obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.generatePremiumIncome
      if (apiURI) {
        try {
          this.loading = true
          let expand = clone(this.reportForm)
          if (expand.cPolType) {
            expand.cPolType = this.reportForm.cPolType.join()
          }
          await this.$http.post(apiURI, expand)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList() {
      this.agentHelpList = true
    }
  },
  created() {
    this.polNoApiUrl = this.$store.state.underwriting.dataTransferSettings.menu.polNoList

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiIntermediaryHelpList
  }
}
</script>

<style>

</style>
